// extracted by mini-css-extract-plugin
module.exports = {"email":"team-module--email--pl0zJ","link":"team-module--link--pwXmw","job":"team-module--job--1c4QZ"};